import { lodash } from '@tarslib/collection/lib/util';
import { merge } from 'lodash';
import Environment from './Environment.js';
import ItemGroup from './ItemGroup.js';
import { VariableList, Version } from '@tarslib/collection';
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SCHEMA_URL = 'https://schema.getpostman.com/json/collection/v2.1.0/collection.json';

// @ts-ignore
var Collection = /*#__PURE__*/function (_ItemGroup) {
  function Collection() {
    var _definition, _definition2, _definition3, _definition4, _definition5;
    var _this;
    var definition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var environments = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, Collection);
    // 去除 header 里自动添加 postman-token
    definition = merge(definition, {
      protocolProfileBehavior: {
        disabledSystemHeaders: {
          'postman-token': true
        }
      }
    });

    // @ts-ignore
    _this = _callSuper(this, Collection, [definition]);
    // @ts-ignore
    _this.variables = new VariableList(_this, (_definition = definition) === null || _definition === void 0 ? void 0 : _definition.variable, environments);
    _this.version = (_definition2 = definition) !== null && _definition2 !== void 0 && (_definition2 = _definition2.info) !== null && _definition2 !== void 0 && _definition2.version ? new Version(definition.info.version) : undefined;
    _this.dataSchemas = (_definition3 = definition) === null || _definition3 === void 0 ? void 0 : _definition3.dataSchemas;
    _this.customFunctions = (_definition4 = definition) === null || _definition4 === void 0 ? void 0 : _definition4.customFunctions;
    _this.mockRules = (_definition5 = definition) === null || _definition5 === void 0 ? void 0 : _definition5.mockRules;
    if (definition.environment) {
      _this.environment = new Environment(definition.environment);
    }
    if (definition.globals) {
      _this.globals = new Environment(definition.globals);
    }
    _this.requestProxyAgentMap = definition.requestProxyAgentMap;
    _this.databaseConnectionMap = definition.databaseConnectionMap;
    return _this;
  }
  _inherits(Collection, _ItemGroup);
  return _createClass(Collection, [{
    key: "syncVariablesFrom",
    value: function syncVariablesFrom(obj, track) {
      return this.variables.syncFromObject(obj, track);
    }
  }, {
    key: "syncVariablesTo",
    value: function syncVariablesTo(obj) {
      return this.variables.syncToObject(obj);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = ItemGroup.prototype.toJSON.apply(this);

      // move ids and stuff from root level to `info` object
      // @ts-ignore
      json.info = {
        _postman_id: this.id,
        name: this.name,
        version: this.version,
        schema: SCHEMA_URL
      };
      delete json.id;
      delete json.name;
      // @ts-ignore
      delete json.version;
      if (json.hasOwnProperty('description')) {
        // @ts-ignore
        json.info.description = this.description;
        delete json.description;
      }
      return json;
    }
  }, {
    key: "itemCount",
    value: function itemCount() {
      var count = 0;
      // @ts-ignore
      this.forEachItem(function (item) {
        count++;
      });
      return count;
    }
  }], [{
    key: "isCollection",
    value: function isCollection(obj) {
      return Boolean(obj) && (obj instanceof Collection || lodash.inSuperChain(obj.constructor, '_postman_propertyName', Collection._postman_propertyName));
    }
  }]);
}(ItemGroup);
_defineProperty(Collection, "_postman_propertyName", 'Collection');
export { Collection as default };
